<template>
  <div>
    <div @click="filterDropdownFlag = false" v-if="filterDropdownFlag === true" class="fixed inset-0 bg-transparent filter-z-index"></div>
    <div class="relative lg:max-w-sm" style="min-width: 100px;" :class="filterDropdownFlag ? 'filter-z-index' : ''">
      <div @click="filterDropdownFlag = !filterDropdownFlag" class="h-btn flex gap-2 justify-between items-center cursor-pointer bg-white rounded border-grey border border-solid p-2">
        <div class="flex items-center gap-1 w-full">
          <feather-icon v-if="icon" :icon="icon" svgClasses="w-4 h-4 flex-shrink-0"></feather-icon>
          <span
            v-if="filters.length === 1 && filters[0] && filterLabel === 'Blu Insights'"
            class="inline-block rounded-full flex-shrink-0 w-4 h-4" :class="filters.length === 1 && filters[0] === 'white' ? 'border border-solid border-orochimaru' : ''"
            :style="{ backgroundColor: getFilterColor(filters[0]) }"
          ></span>
          <p class="truncate w-full text-center capitalize font-medium text-sm whitespace-nowrap overflow-hidden">
            {{ filters.length === 0 ? filterLabel && filterLabel.length > 0 ? $t(filterLabel): $t('All Selected') : $route.name.includes('exchanges') ? filters.map(item => $t(exchangeFiltersDic[item])) : filters.map(item => filterLabel === 'Pricing Plan' ? pricingPackagesDic[item] : ['Attempts', 'Blu Insights', 'Merchant'].includes(filterLabel) ? $t(getStatusFilterName(item)) : $t(String(item).replaceAll('_', ' '))).join(', ')}}
          </p>
          <feather-icon class="w-4 h-4 flex-shrink-0" :icon="filterDropdownFlag ? 'ChevronUpIcon' : 'ChevronDownIcon'"></feather-icon>
        </div>
      </div>
      <div v-if="filterDropdownFlag" class="absolute w-76 left-0 bg-white p-2 rounded border-grey border border-solid" style="top: 40px;">
        <div @click="changeFilter(item.value)" v-for="item in statusFilters" :key="item.index">
          <vs-checkbox class="mb-2 " :checked="filters.length === 0 && item.value === 'all' && checkFlag  ? true : filters.includes(item.value)" :vs-value="item.value">
            <span class="flex items-center gap-2">
              <span
                v-if="item.value && filterLabel === 'Blu Insights'"
                class="inline-block rounded-full flex-shrink-0 w-4 h-4" :class="item.value === 'white' ? 'border border-solid border-orochimaru' : ''"
                :style="{ backgroundColor: getFilterColor(item.value) }"
              >
              </span>
              <span class="capitalize">{{ $t(item.name) }}</span>
            </span>
          </vs-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['statusFilters', 'filters', 'filterLabel', 'icon', 'pricingPackagesDic', 'colorsMap'],
  data () {
    return {
      filterDropdownFlag: false,
      checkFlag:true,
      exchangeFiltersDic: {
        'all': 'all', 
        'delivery_order_status=created,pickup_requested,out_for_pickup&return_order_status=created,return_requested': 'created',
        'delivery_order_status=picked_up,in_transit,en_route,out_for_delivery,delivery_attempted&return_order_status=created,return_requested,return_attempted': 'picked up to exchange',
        'delivery_order_status=delivered&return_order_status=picked_up,in_transit,en_route,return_postponed,return_refused': 'swapping',
        'delivery_order_status=delivered&return_order_status=returned': 'exchanged',
        'delivery_order_status=cancelled,delivery_attempted&return_order_status=cancelled,return_refused': 'failed to exchange'
      }
    }
  },
  watch :{
    '$route.query.flag' (val) {
      this.checkFlag = val && val.length === 0
    }
  },
  methods: {
    getFilterColor (value) {
      const colorKey = typeof value === 'string' ? value.trim().toLowerCase() : ''
      const activeColorsMap = this.colorsMap || {}
      return colorKey && activeColorsMap[colorKey] ? activeColorsMap[colorKey] : null
    },
    getStatusFilterName (value) {
      if (!Array.isArray(this.statusFilters)) {
        return String(value).replaceAll('_', ' ')
      }
      const matchedOption = this.statusFilters.find(item => item.value === value)
      return matchedOption && matchedOption.name ? matchedOption.name : String(value).replaceAll('_', ' ')
    },
    changeFilter (type) {
      this.$emit('filterValue', type)
      this.$emit('changeFilter')
    }
  }
}
</script>

<style>
.filter-z-index {
  z-index: 9999;
  user-select: none;
}
</style>